import { action, thunk } from 'easy-peasy'

import BaseModel from '../Base'
import api from '../../api'
import { NETWORK_STATUS } from '../../Constants'
import { SUPER_CLINIC_USER_ID, DOCTOR_ID } from '../../Constants'
export default {
  ...BaseModel()
}
